import { memo, ReactNode, useEffect, useState } from "react";
import { nodeContextBridge } from "helpers/nodeContextBridge";
import { CrossRootSharedContexts } from "models/CrossRootSharedContexts";

interface ComponentWrapperProps {
    children: ReactNode;
}

const CrossRootContextWrapper = ({ children }: ComponentWrapperProps) => {
    const [contexts, setContexts] = useState<CrossRootSharedContexts | null>(
        () => nodeContextBridge.getContexts()
    );

    useEffect(() => {
        if (!contexts) {
            return nodeContextBridge.subscribe(setContexts);
        }
    }, [contexts]);

    if (!contexts) {
        return null;
    }

    return contexts.createProviders(children) as JSX.Element;
}

export default memo(CrossRootContextWrapper);